module.exports = __webpack_public_path__ + "static/media/burger.21ec1848.jpg";